import { SIZING_METHOD } from '@voladeum/client';
import { InputNumber, InputPercent } from 'framework/Input';
import { TypedValue } from 'framework/Input/types';

import { EMPTY_FUNCTION } from '../../../constants';

interface SizingMethodInputProps {
  label: string;
  value: string;
  sizing_method_id: SIZING_METHOD;
  onChange: (typed_value: TypedValue) => void;
}

export const SizingMethodInput = ({
  label,
  value,
  sizing_method_id,
  onChange = EMPTY_FUNCTION,
}: SizingMethodInputProps) => {
  if (SIZING_METHOD.PERCENTAGE === sizing_method_id) {
    return <InputPercent label={label} value={value} onChange={onChange} />;
  }
  return <InputNumber label={label} value={value} onChange={onChange} />;
};
